<template>
  <div class="register">
    <div class="main">
      <!-- <div class="header" v-if="isMobile">
        <router-link to="/" style="display: contents">
          <div class="l-text">
            <img src="@/assets/images/register/logo.png" alt="" />
          </div>
        </router-link>
        <div class="r-text">
          已有账号，
          <span @click="login">马上登录</span>
        </div>
      </div> -->
      <div class="content">
        <div class="l-img"></div>
        <div class="tabs">
          <div class="t" @click="switchLogin" v-if="windowW > 850">
            <span class="t1">已有帐号，</span>
            <span class="t2">马上登录</span>
          </div>
          <div class="t" v-else>
            <span class="t1">已有帐号，</span>
            <a class="t2" href="login">马上登录</a>
          </div>
          <el-tabs v-model="activeName" class="e-tabs" @tab-click="handleClick">
            <el-tab-pane label="注册" name="register">
              <div class="form">
                <el-form
                  ref="ruleFormRef"
                  :model="ruleForm"
                  :rules="rules"
                  class="demo-ruleForm mt20"
                >
                  <el-form-item label="+86" prop="mobile" class="numItem">
                    <el-input
                      v-model="mobile"
                      placeholder="请输入手机号"
                      class="el-int"
                      maxlength="11"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="code" class="mt20">
                    <el-input
                      v-model="code"
                      class="el-int code register-code"
                      autocomplete="off"
                      maxlength="6"
                    ></el-input>
                    <el-button
                      type="primary"
                      class="send"
                      style="color:#000;"
                      @click="send"
                      v-if="isShowSend"
                      >发送验证码</el-button
                    >
                    <div class="sendTime" v-if="!isShowSend">
                      {{ timeNum }}S重新发送
                    </div>
                  </el-form-item>
                  <el-form-item label="输入密码" class="mt20" prop="password">
                    <el-input
                      v-model="password"
                      placeholder="请输入密码"
                      class="el-int"
                      type="password"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="确认密码"
                    class="mt20"
                    prop="password_confirmation"
                    autocomplete="off"
                  >
                    <el-input
                      v-model="password_confirmation"
                      placeholder="请再次输入密码"
                      class="el-int"
                      type="password"
                    ></el-input>
                  </el-form-item>
                  <el-button
                    type="primary"
                    :class="isAffirm ? 'register-btn isAffirm' : 'register-btn'"
                    :disabled="!isAffirm"
                    @click="submit(ruleFormRef)"
                    >注册</el-button
                  >
                  <div class="server">
                    <el-checkbox
                      v-model="server"
                      size="large"
                      class="checkbox"
                    ></el-checkbox>
                    我已阅读并同意知鸦
                    <router-link to="/serviceAgree">《用户协议》</router-link
                    >和<router-link to="/intimityPolicy"
                      >《隐私政策》</router-link
                    >
                  </div>
                </el-form>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!-- <div class="form" v-show="isMobile">
          <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" class="demo-ruleForm mt20">
            <el-form-item label="+86" prop="mobile">
              <el-input v-model="mobile" placeholder="请输入手机号" class="el-int" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="code" class="mt20">
              <el-input v-model="code" class="el-int code register-code" autocomplete="off" maxlength="6"
              ></el-input>
              <el-button type="primary" class="send" @click="send" v-if="isShowSend" >发送验证码</el-button>
              <div class="sendTime" v-if="!isShowSend">
                {{ timeNum }}S重新发送
              </div>
            </el-form-item>
            <el-form-item label="输入密码" class="mt20" prop="password">
              <el-input v-model="password" placeholder="请输入新密码" class="el-int" type="password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" class="mt20" prop="password_confirmation" autocomplete="off">
              <el-input v-model="password_confirmation" placeholder="请再次输入密码" class="el-int" type="password"></el-input>
            </el-form-item>
            <el-button type="primary" class="register-btn" @click="submit(ruleFormRef)" >注册</el-button>
            <div class="server">
              <el-checkbox v-model="server" size="large" class="checkbox"></el-checkbox>
              我已阅读并同意知鸦
              <router-link to="/serviceAgree">《用户协议》</router-link>和<router-link to="/intimityPolicy">《隐私政策》</router-link>
            </div>
          </el-form>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  reactive,
  ref,
  toRefs,
  defineComponent,
  onMounted,
  onBeforeMount,
  watchEffect,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import type { ElForm } from "element-plus";
import { sendCode, userRegister } from "@/api/login/index";
import { ElMessage } from "element-plus";
type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  name: "register",

  setup({}, { emit }) {
    const router = useRouter();
    const isShowSend = ref(true);
    const timeNum = ref(60);
    const countDown = ref();
    const ruleFormRef = ref<FormInstance>();
    const server = ref<Boolean>(true);
    const ruleForm = reactive({
      mobile: "",
      code: "",
      password: "",
      password_confirmation: "",
    });
    const isMobile = ref(false);
    const activeName = ref("register");
    const isAffirm = ref(false);
    onBeforeMount(() => {
      if (navigator.userAgent.match(/mobile/i)) {
        isMobile.value = true;
      }
    });

    onMounted(() => {});
    const vaildateMobile = (rule: any, value: any, callback: any) => {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const rules = reactive({
      mobile: [
        {
          required: true,
          message: "请输入手机号",
          trigger: "blur",
        },
        { validator: vaildateMobile, trigger: "change" },
      ],
      password: [
        {
          required: true,
          message: "请输入新密码",
          trigger: "blur",
        },
      ],
      code: [
        {
          required: true,
          message: "请输入验证码",
          trigger: "blur",
        },
      ],
      password_confirmation: [
        {
          required: true,
          message: "请再次输入密码",
          trigger: "blur",
        },
      ],
    });

    const login = (): void => {
      router.push({ name: "login" });
    };
    const send = (): void => {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(ruleForm.mobile)) {
        ElMessage({
          type: "error",
          message: "请输入正确的手机号",
        });
        return;
      }
      sendCode({ mobile: ruleForm.mobile }).then((res: any) => {
        if (res.code == 0) {
          ElMessage.success(res.msg);
          getSetInterval();
        }
      });
    };

    //倒计时60s
    const getSetInterval = (): void => {
      timeNum.value = 60;
      countDown.value = setInterval(() => {
        setTimeout(() => {
          if (timeNum.value > 0 && timeNum.value <= 60) {
            isShowSend.value = false;
            timeNum.value--;
          } else {
            isShowSend.value = true;
            clearInterval(countDown.value);
          }
        }, 0);
      }, 1000);
    };

    const submit = (formEl: FormInstance | undefined): void => {
      (formEl as any).validate((valid: any) => {
        if (valid) {
          console.log(ruleForm);
          let data = Object.assign(ruleForm, {
            consent_agreement: server.value ? 1 : 0,
          });
          userRegister(data).then((res: any) => {
            if (res.code == 0) {
              ElMessage.success("注册成功");
              if (windowW > 850) {
                emit("switch", "login");
              } else {
                router.push({ name: "login" });
              }
            }
          });
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    const switchLogin = () => {
      emit("switch", "login");
    };
    watchEffect(() => {
      if (
        ruleForm.mobile.length == 11 &&
        ruleForm.code.length == 6 &&
        ruleForm.password.length > 5 &&
        ruleForm.password_confirmation.length > 5
      ) {
        isAffirm.value = true;
      } else {
        isAffirm.value = false;
      }
    });
    // 判断是pc端还是移动端
    const windowW = window.innerWidth;
    return {
      windowW,
      login,
      switchLogin,
      rules,
      isShowSend,
      timeNum,
      countDown,
      ...toRefs(ruleForm),
      ruleFormRef,
      ruleForm,
      server,
      submit,
      send,
      isMobile,
      activeName,
      isAffirm,
    };
  },
});
</script>
<style lang="less">
@import url("@/assets/styles/login.less");
.register {
  .checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #ffca28;
    border-color: #ffca28;
  }
  .checkbox .el-checkbox__inner:hover {
    border-color: #ffca28;
  }
  input:-webkit-autofill {
    box-shadow: 0 0 0px 1000px #f0f0f0 inset;
    -webkit-text-fill-color: #f0f0f0;
    caret-color: #f0f0f0;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    box-shadow: 0 0 0px 1000px #f0f0f0 inset;
  }
  .tabs {
    .e-tabs {
      width: 100%;
      height: 100%;
      .el-tabs__nav-scroll {
        font-size: 14px;
      }
      .el-tabs__content,
      .el-tab-pane {
        height: 100%;
      }
      .el-tabs__item {
        font-size: 18px !important;
        color: #999999 !important;
        font-weight: bold;
      }
      .el-tabs__item.is-active {
        background-color: #fff !important;
        color: #191c29 !important;
      }
      .el-tabs__active-bar {
        background-color: #191c29 !important;
        height: 3px;
      }
      .el-tabs__nav-wrap {
        height: 60px;
        .el-tabs__nav {
          display: block;
        }
      }
      .is-top {
        background: white;
        margin: 0;
      }
      .el-tabs__header {
        padding: 0 30px;
      }
    }
  }

  .register-code .el-input__inner {
    width: 100% !important;
  }
}

@media only screen and (max-width: 850px) {
  body,
  html {
    height: 100%;
  }
  .register {
    .tabs {
      .e-tabs {
        .el-tabs__header {
          padding: 0;
        }
      }
    }
    .el-form-item {
      margin-bottom: 16px;
    }
  }
}
</style>
<style lang="less" scoped>
@import url("@/assets/styles/common.less");
.register {
  .boxSize(100%,100%);
  overflow: hidden;
  .main {
    .boxSize(100%,100%);
    .header {
      height: 40px;
      .Flex(space-between);
      .r-text {
        .font(#999999,14px);
        .pointer();
        span {
          color: #232633;
        }
      }
    }
    .content {
      .Flex(center);
      height: 460px;
      .title {
        .boxSize(100%,72px,72px);
        text-align: center;
        background-color: @bg_color;
        .font(#191c29,16px);
      }

      .l-img {
        height: 100%;
        background: url("@/assets/images/register/left_bg.png");
        background-size: 100% 100%;
        padding: 30px;
        box-sizing: border-box;
        position: relative;
        width: 45%;
      }
      .tabs {
        width: 55%;
        position: relative;

        .t {
          position: absolute;
          .pointer();
          .Position(absolute,none,0px,30px,none);
          z-index: 99999;
          font-size: 16px;
          .t1 {
            color: #999999;
          }
          .t2 {
            color: #333;
          }
        }
        .form {
          padding: 30px;
          .boxSize(calc(100% - 60px),100%);
          background: #fff;
          overflow: hidden;
          padding-top: 0px;
          .send {
            border: none;
            .boxSize(49%,40px);
            background: #f4f4f4;
            .font(#191c29,15px);
          }
          .sendTime {
            .boxSize(160px,40px);
            border-radius: 4px;
            background-color: #f0f0f0;
            .font(#9f9f9f,15px);
            border: none;
            line-height: 40px;
            text-align: center;
          }
          .register-btn {
            border: none;
            .boxSize(100%,40px);
            background: #f1f1f1;
            .font(#D1D2D5,16px);
            &:hover {
              background: #f1f1f1;
              .font(#D1D2D5,16px);
            }
            &.isAffirm {
              background: #ffca28;
              color: #333333;
              &:hover {
                background: #ffca28;
                color: #333333;
              }
            }
          }
          .register-code {
            width: 49% !important;
          }
        }
        .server {
          .font(#333,13px);
          margin-top: 10px;
          line-height: 20px;
          a {
            color: #ffca28;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 850px) {
  .register {
    background-size: 100% 100%;
    padding: 20px;
    box-sizing: border-box;
    .boxSize(100%,calc(100% - 20px));
    .main {
      width: 100%;
      .content {
        display: block;
        .l-img {
          display: none;
        }
        .title {
          height: 70px;
          .boxSize(100%,50px,50px);
        }
        .tabs {
          width: 100%;
          .t {
            top: 8px;
            right: 0;
          }
          .form {
            padding: 0;
            width: 100%;
            margin-top: 40px;
            .server {
              margin-top: 20px;
              font-size: 14px;
              a {
                color: @bg_color;
              }
            }
            .send {
              background: #f4f4f4;
              color: #999999;
              .boxSize(3.2rem,40px);
            }
            .sendTime {
              .boxSize(3.2rem,40px);
            }
          }
        }
      }
    }
  }
}
</style>